import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralMySpaces = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(223, 223, 223, 0.3);
`;

export const ContentHeaderMySpace = styled.div`
  display: inline-flex;
  align-items: center;
  width: 98%;
`;

export const TitleMySpace = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-weight: 700;
  width: 20%;
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1em 0;
  width: 100%;
`;

export const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 7vw 4fr 1fr;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 11vw 4fr 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 11vw 4fr 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
  }
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 20px;
  }
`;

export const ContentFilterButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 6em;
  height: 4em;
  margin: 0.5em 0px 0px 0px;
  align-items: center;
  display: flex;
  justify-content: center;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  &:hover {
    cursor: pointer;
    border-top: 1px solid
      ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const useStyles = makeStyles(() => ({
  contentForMySpaces: {
    backgroundColor: theme.neutral.white,
    margin: "1.5em",
  },
}));
